import _ from "underscore";
import { findContext } from "@/components/services/Tools";

const defaultContext = "esreps";

let maps = {
    esreps: {
        slide: 12,
        buttons_image: 13,
        top: 11,
        icons: 14,
        news: 117,
        faqs: 71,
        learning_center: 108,
    },
    colreps: {
        // Temp disables
        //slide: 173,
        //buttons_image: 13,
        //top: 172,
        //icons: 14,
        //news: 176,
        //faqs: 175,
        //learning_center: 108,
        slide: 173,
        buttons_image: 13,
        top: 11,
        icons: 14,
        news: 174,
        faqs: 175,
        learning_center: 108,
    }
};

export const generateMap = function() {
    let context = findContext();
    if (_.has(maps, context)) {
        return maps[context];
    }
    return maps[defaultContext];
};



// WEBPACK FOOTER //
// ./src/components/services/Wapi.js